
<template>

	<v-card>
		<v-toolbar flat dense cad>
			<v-toolbar-title class="subheading">
				Daily Scrum
				<span class="info-text"> - {{ dailyScrum.scrumDateUtc | formatDate('dddd, DD MMM YYYY') }}</span>
			</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-divider></v-divider>
		<v-card-text>

			<v-layout row wrap>
				<v-flex md7>
					<v-card flat class="mb-2 question-card" v-for="(item, index) in form.items" :key="`scrum-item-${index}`">
						<v-card-text>
							<h3 class="question-card-title mb-2">{{item.question}}</h3>

							<div v-if="item.rankType == 0">
								<v-textarea hide-details box :autofocus="index===0" :ref="`answer${index}`" class="item-textarea" auto-grow :placeholder="textPlaceholder" v-model="item.answer" :rows="3"></v-textarea>
							</div>

							<div v-else-if="item.rankType == 1">
								<span class="item tl-red" :class="setClass(item, 0)" @click="setAnswer(item, 0)">
									<v-icon>mdi-circle</v-icon>
								</span>
								<span class="item tl-amber" :class="setClass(item, 1)" @click="setAnswer(item, 1)">
									<v-icon>mdi-circle</v-icon>
								</span>
								<span class="item tl-green" :class="setClass(item, 2)" @click="setAnswer(item, 2)">
									<v-icon>mdi-circle</v-icon>
								</span>
							</div>

							<div v-else-if="item.rankType == 2">
								<span class="item very-sad is-not-selected" :class="setClass(item, 0)" @click="setAnswer(item, 0)">
									<v-icon>mood_bad</v-icon>
								</span>
								<span class="item sad is-not-selected" :class="setClass(item, 1)" @click="setAnswer(item, 1)">
									<v-icon>mdi-emoticon-sad-outline</v-icon>
								</span>
								<span class="item neutral is-not-selected" :class="setClass(item, 2)" @click="setAnswer(item, 2)">
									<v-icon>mdi-emoticon-neutral-outline</v-icon>
								</span>
								<span class="item happy is-not-selected" :class="setClass(item, 3)" @click="setAnswer(item, 3)">
									<v-icon>mdi-emoticon-happy-outline</v-icon>
								</span>
								<span class="item very-happy is-not-selected" :class="setClass(item, 4)" @click="setAnswer(item, 4)">
									<v-icon>mood</v-icon>
								</span>
							</div>

							<div v-else>
								<span class="not-answered-text">Uh oh! Couldn't get this answer.</span>
							</div>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex md5 class="last-scrum-panel">
					<v-card>
						<v-toolbar flat dense cad class="info" dark>
						<v-toolbar-title class="subheading">
							{{ lastDailyScrumTitle }} <span v-if="lastDailyScrum" class="info-text"> - {{ lastDailyScrum.scrumDateUtc | formatDate('dddd, DD MMM YYYY') }}</span>
						</v-toolbar-title>

						</v-toolbar>
						<v-card-text>
							<daily-scrum :dailyScrum="lastDailyScrum" />
						</v-card-text>						
					</v-card>
					
				</v-flex>
			</v-layout>

		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn flat @click="onCancel">Cancel</v-btn>
			<v-btn color="primary" :loading="isSubmitting" :disabled="isSubmitting" flat @click="submitForm">Save
				<span slot="loader">Saving...</span>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import moment from 'moment';

	import DailyScrum from '@/components/dailyScrum/DailyScrum';

	export default {
		props: {
			dailyScrum: {
				required: true,
				type: Object
			},
			lastDailyScrum: {
				required: false,
				type: Object
			},
			loggedInEmployee: {
				type: Object,
				required: true
			},
			isSubmitting: {
				required: true,
				type: Boolean
			}
		},
		data() {
			return {
				form: {}
			};
		},
		components: {
			DailyScrum
		},
		mixins: [validationMixin],
		validations: {},
		created() {
			this.form = JSON.parse(JSON.stringify(this.dailyScrum));
		},
		methods: {
			setClass(item, expectedAnswer) {
				var classes = [];
				if (this.dailyScrum.employee.id !== this.loggedInEmployee.id) {
					classes.push('mouse-disabled-input');

					if (item.answer === null) {
						classes.push('is-not-selected');
					} else {
						classes.push(Number(item.answer) === expectedAnswer ? 'is-selected' : 'is-not-selected');
					}
					return classes;
				}

				classes.push('grow-on-hover');

				if (item.answer === null) {
					return classes;
				}

				classes.push(Number(item.answer) === expectedAnswer ? 'is-selected' : 'is-not-selected');
				return classes;
			},
			setAnswer(item, answer) {
				if (this.isLoggedInEmployee) {
					item.answer = answer;
				}
			},
			getClass(result) {
				switch (result) {
					case 0:
						return 'error';
					case 1:
						return 'warning';
					case 2:
						return 'success';
				}
			},
			getHappyIcon(result) {
				switch (result) {
					case 0:
						return 'mdi-emoticon-cry-outline';
						break;
					case 1:
						return 'mdi-emoticon-sad-outline';
						break;
					case 2:
						return 'mdi-emoticon-neutral-outline';
						break;
					case 3:
						return 'mdi-emoticon-happy-outline';
						break;
					case 4:
						return 'mdi-emoticon-outline';
						break;
					default:
						return '';
						break;
				}
			},
			onCancel() {
				this.$emit('onCancel');
			},
			submitForm() {
				this.$emit('save', this.form);
			}
		},
		computed: {
			textPlaceholder() {
				if (this.isLoggedInEmployee) {
					return 'Type your answer here.';
				} else {
					return 'Not yet answered.';
				}
			},
			isLoggedInEmployee() {
				return this.loggedInEmployee.id === this.dailyScrum.employee.id;
			},
			lastDailyScrumTitle() {
				if (this.lastDailyScrum) {
					if (moment(this.lastDailyScrum.scrumDateUtc).format('YYYY-MM-DD') == moment().add(-1, 'days').format('YYYY-MM-DD')) 
						return "Yesterday's Scrum";
				}
				return "Your last Daily Scrum";
			}
		}
	};
</script>

<style scoped>
	.item {
		cursor: pointer;
	}

	.item i {
		font-size: 4em !important;
		border-radius: 50%;
	}

	.very-happy i {
		color: rgb(92, 182, 36);
	}

	.happy i {
		color: rgb(170, 195, 32);
	}

	.neutral i {
		color: rgb(244, 197, 17);
	}

	.sad i {
		color: rgb(246, 142, 31);
	}

	.very-sad i {
		color: rgb(245, 77, 28);
	}

	.tl-red i {
		color: #f44336 !important;
	}

	.tl-amber i {
		color: #ffc107 !important;
	}

	.tl-green i {
		color: #4caf50 !important;
	}

	.question-card-title {
		font-weight: 500;
	}

	.question-card {
		text-align: left;
	}

	.comment-text {
		text-align: left;
	}
	.comment-date {
		text-align: left;
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px;
		font-style: italic;
	}

	.grow-on-hover {
		display: inline-block;
		vertical-align: middle;
		-webkit-transform: perspective(1px) translateZ(0);
		transform: perspective(1px) translateZ(0);
		box-shadow: 0 0 1px rgba(0, 0, 0, 0);
		-webkit-transition-duration: 0.3s;
		transition-duration: 0.3s;
		-webkit-transition-property: transform;
		transition-property: transform;
	}

	.is-not-selected {
		opacity: 0.35;
	}

	.is-selected {
		opacity: 1;
	}
	.is-selected i {
		color: #fff;
	}
	.is-selected.very-happy i {
		background-color: rgb(92, 182, 36);
	}
	.is-selected.happy i {
		background-color: rgb(170, 195, 32);
	}
	.is-selected.neutral i {
		background-color: rgb(244, 197, 17);
	}
	.is-selected.sad i {
		background-color: rgb(246, 142, 31);
	}
	.is-selected.very-sad i {
		background-color: rgb(245, 77, 28);
	}

	.grow-on-hover:hover,
	.grow-on-hover:focus,
	.grow-on-hover:active {
		-webkit-transform: scale(1.2);
		transform: scale(1.2);
		opacity: 1;
	}

	.mouse-disabled-input:hover {
		cursor: not-allowed;
	}

	.answer {
		color: rgba(0, 0, 0, 0.54);
	}

	.info-text {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px !important;
	}

	.theme--dark .info-text {
		color: #fff;
	}

	/* .last-scrum-panel {
		background-color: #f5f5f5;
	} */

	/* .v-textarea.v-text-field--enclosed textarea {
				margin-top:8px !important;
			} */
</style>
<style>
	.item-textarea textarea {
		margin-top: 8px !important;
	}
</style>
